import React from 'react';
//import styles from './styles.module.scss'

const  RadioButton = ({name,id,label,value, checkedRadio, selectedRadioValue, fontSize="", strikeText='',inputClassName='',labelClassName='' }) => {
  //const [selectedValue,setSelectedValue] = useState(value)
  const handleChange= (e) => {
    //setSelectedValue(e.currentTarget.value)
    selectedRadioValue(e.currentTarget.value)
  }
  return (
    <div className="custom-control custom-checkbox">
        <input className={inputClassName} value={value} type="radio" name={name} id={id} checked={checkedRadio === "checked"} onChange={(e) => handleChange(e)}/>
        <label className={labelClassName}  htmlFor={id} style={{fontSize: fontSize+'px'}}>
            {label}  
        </label>
    </div>
  );
}

export default RadioButton;
